export const extractPinVerificationDigit = value => {
  return value.replace(/\D/g, '').charAt(0) || '';
};
export const getCookieValue = key => {
  if (typeof document === 'undefined') return '';

  return (
    document.cookie
      ?.split('; ')
      ?.find(row => row.startsWith(`${key}=`))
      ?.substring(key.length + 1) || ''
  );
};
